import { Component, Input, Type, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-drawer-container',
  imports: [],
  templateUrl: './drawer-container.component.html',
  styleUrl: './drawer-container.component.css'
})
export class DrawerContainerComponent {
  @Input( {required: true} ) title!: string;
  @Input( {required: true} ) component!: Type<any>;
  @Input(  {required: true} ) data: any;
  @Input() showActions: boolean = false;

  @ViewChild('content', { read: ViewContainerRef })  content!: ViewContainerRef;

  @Input() close!: () => void;
  confirm?: () => void;

  
  ngAfterViewInit() {
    const componentRef = this.content.createComponent(this.component);
    
    if (this.data) {
      componentRef.setInput('data', this.data);
    }

    componentRef.setInput('cancel', this.close)
  }
}
